__turbopack_context__.v({
  "blok-big-title": "TextBannerBlok-module__DW_j8a__blok-big-title",
  "blok-subtitle": "TextBannerBlok-module__DW_j8a__blok-subtitle",
  "blok-title": "TextBannerBlok-module__DW_j8a__blok-title",
  "group": "TextBannerBlok-module__DW_j8a__group",
  "innermedia": "TextBannerBlok-module__DW_j8a__innermedia",
  "innertext": "TextBannerBlok-module__DW_j8a__innertext",
  "media": "TextBannerBlok-module__DW_j8a__media",
  "richtext": "TextBannerBlok-module__DW_j8a__richtext",
  "right": "TextBannerBlok-module__DW_j8a__right",
  "text": "TextBannerBlok-module__DW_j8a__text",
  "textWrap": "TextBannerBlok-module__DW_j8a__textWrap",
  "title": "TextBannerBlok-module__DW_j8a__title",
  "titleWrap": "TextBannerBlok-module__DW_j8a__titleWrap",
  "wrapper": "TextBannerBlok-module__DW_j8a__wrapper",
});
